import script from "./DocumentVerification.vue?vue&type=script&setup=true&lang=js"
export * from "./DocumentVerification.vue?vue&type=script&setup=true&lang=js"

import "./DocumentVerification.vue?vue&type=style&index=0&id=1ad3e286&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ad3e286"]])

export default __exports__